<script setup>
import { ref } from 'vue'
import { useEventStore } from '@stores/event'
import { useRoute, useRouter } from 'vue-router'
import Hero from '@sections/global/Hero.vue'
import GalleryImage from '@components/gallery/GalleryImage.vue'
import Loading from '@components/global/Loading.vue'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const event = ref({})
const requestEvent = ref(null)

const breadcrumbs = ref([
	{
		label: 'Back to Media Galleries',
		to: { name: 'galleries' },
	},
])

function cancelEvent() {
	if (requestEvent.value) requestEvent.value.cancel()
}
function getEvent() {
	loading.value = true
	event.value = {}
	cancelEvent()
	let axiosSource = axios.CancelToken.source()
	requestEvent.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/tournament/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((a) => {
			loading.value = false
			event.value = a.data
			breadcrumbs.value.push({
				label: event.value.name,
			})
		})
		.catch((e) => {
			if (e?.response?.status === 404) {
				router.push('/media-gallery')
			}
		})
}
getEvent()
</script>

<template>
	<Loading v-if="loading" />
	<template v-else>
		<Hero :title="event.name" :breadcrumbs="breadcrumbs" />
		<section class="mb-10">
			<div class="container">
				<div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
					<GalleryImage v-for="image in event.gallery" :key="image" :image="image" />
				</div>
			</div>
		</section>
	</template>
</template>
